/**
 * The one way a URL filter's params are written, everywhere one is (`domain/rowFilter.ts`,
 * `domain/auditFilter.ts`, `pages/games/gamesFilter.ts`): a patch of `key: value` pairs, an
 * empty value deleting its key rather than writing it blank, so an unfiltered URL stays bare.
 */
export const setParams = (
    params: URLSearchParams,
    patch: Record<string, string | null | undefined>,
): URLSearchParams => {
    const next = new URLSearchParams(params);
    for (const [key, value] of Object.entries(patch)) {
        if (value) next.set(key, value);
        else next.delete(key);
    }
    return next;
};
